<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-card>
      <v-card-text class="pa-5">
        <v-row>
          <v-col>
            <review-form
              :review="review"
              :errors="errors"
              @onSubmit="submit"
            ></review-form>
          </v-col>
        </v-row>
        <v-snackbar
          v-model="snackbarSuccess"
          :timeout="timeout"
          color="success"
        >
          Сохранено

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              @click="snackbarSuccess = false"
              color="red"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        <v-snackbar
          v-model="snackbarError"
          :timeout="timeout"
          color="error"
        >
          {{ this.errors }}

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              @click="snackbarError = false"
              color="red"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {Review} from "../../../models/review";
import ReviewForm from "../../../components/reviews/ReviewForm";

export default {
  name: 'Edit',
  components: {
    ReviewForm,
  },
  data: () => ({
    review: {},
    errors: {},
    snackbarSuccess: false,
    snackbarError: false,
    page: {
      title: "Редактирование отзыва"
    },
    breadcrumbs: [
      {
        text: "Админ панель",
        disabled: false,
        to: '/'
      },
      {
        text: "Отзывы",
        disabled: true,
        to: '/reviews'
      },
      {
        text: "Редактирование",
        disabled: true,
        to: '/reviews/create'
      },
    ],
  }),
  created() {
    this.find();
  },
  methods: {
    async submit({ form, isNeedRedirect }) {
      try {
        this.errors = {};
        await Review.$query().update(form.id, form);
        await this.find();
        this.snackbarSuccess = true;

        if (isNeedRedirect) {
          await this.$router.push({name: 'reviews-index'});
        }
      } catch (e) {
        if (e.response?.data) {
          this.errors = e.response.data.errors;
          this.snackbarError = true;
        }
        throw e;
      }
    },
    async find() {
      const review = await Review.$query().find(this.$route.params.id);
      this.review = review.$attributes;
    },
  },
};
</script>
